function getLabelText(label) {
  switch (label) {
    case "Free":
      return "Gratis";
    case "New":
      return "Nyt";
    case "Newest":
      return "Ny version";
    case "Popular":
      return "Popul\xE6rt";
    case "Upcoming":
      return "P\xE5 vej";
    case "Updated":
      return "Opdateret";
    case "Topical":
      return "Aktuelt";
    case "Expires":
      return "Udg\xE5r";
  }
}

export { getLabelText };
//# sourceMappingURL=typings.page-descriptor.js.map
